<template>
	<pre v-html="$t('terms.agreement8')"></pre>
</template>

<script>
export default {
	name: 'Agreement8',
};
</script>

<style scoped></style>
